<template>
    <v-list-item 
        v-if="isRouteAllowed" 
        link 
        :to="'/incident-records'" 
        class="pr-0 pl-12"
    >
        <v-list-item-content class="py-0">
            <v-list-item-title>Картотека инцидентов</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'IncidentRecordsMenuItem',

    computed: {
        isRouteAllowed() {
            const user = this.$store.state.auth.user;
            if (!user) return false;

            const userId = parseInt(user.userID || 0);
            const allowedUsers = [10, 20, 23, 45];

            return allowedUsers.includes(userId);
        }
    }
}
</script>